// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__4p4Vd","header":"layout_header__wJ3SC","title":"layout_title__kTRWz","headerChildren":"layout_headerChildren__dbc6a","body":"layout_body__Ik9wa"};